<template>
  <main class="main sty">

    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <!-- Hero -->
    <section class="sty-hero">
      <div class="container sty-hero__container">

        <div class="sty-hero__content">
          <div class="sty-hero__label">Стиль</div>
          <h1 class="title sty-hero__title">
            Стиль, чтобы брать<br>от жизни всё
          </h1>
          <p class="sty-hero__desc">
            Создавай и сохраняй впечатление о себе
          </p>
          <p class="sty-hero__lead">
            Хочешь, мы соберём тебе образ?
          </p>
          <div class="sty-hero__actions">
            <button class="btn main-btn" @click="isModalOpen = true">
              Собрать образ
            </button>
            <a href="#for-brands" class="sty-hero__link">
              Разместить бренд
            </a>
          </div>
        </div>

        <div class="sty-hero__image">
          <img
            src="/img/services/style/hero.jpg"
            alt="Стиль — Шарунстор"
            loading="eager"
          />
        </div>

      </div>
    </section>

    <!-- Каталог -->
    <section class="sty-catalog">
      <div class="container">

        <div class="sty-catalog__head">
          <h2 class="title sty-catalog__title">Не только имидж, но и ощущение себя</h2>
          <p class="sty-catalog__desc">Соберём свой собственный стиль из одежды, обуви, аксессуаров и даже белья.</p>
        </div>

        <div class="sty-catalog__tabs">
          <button
            class="sty-catalog__tab"
            :class="{ 'sty-catalog__tab--active': activeGender === 'women' }"
            @click="activeGender = 'women'"
          >Женщинам</button>
          <button
            class="sty-catalog__tab"
            :class="{ 'sty-catalog__tab--active': activeGender === 'men' }"
            @click="activeGender = 'men'"
          >Мужчинам</button>
        </div>

        <Swiper
          :key="activeGender"
          :modules="[SwiperNavigation]"
          :slides-per-view="1.3"
          :space-between="16"
          :navigation="true"
          :breakpoints="{
            640:  { slidesPerView: 2.3, spaceBetween: 20 },
            1024: { slidesPerView: 3.5, spaceBetween: 24 },
            1280: { slidesPerView: 4,   spaceBetween: 24 },
          }"
          class="sty-catalog__swiper"
        >
          <SwiperSlide v-for="cat in activeCats" :key="cat.name">
            <div class="sty-catalog__card">
              <div class="sty-catalog__card-img">
                <img :src="cat.img" :alt="cat.name" loading="lazy" />
              </div>
              <div class="sty-catalog__card-overlay" />
              <div class="sty-catalog__card-body">
                <span class="sty-catalog__card-name">{{ cat.name }}</span>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

      </div>
    </section>

    <!-- Витрина концептов -->
    <section class="sty-concepts">
      <div class="container">

        <div class="sty-concepts__head">
          <h2 class="title sty-concepts__title">Собери свой образ</h2>
          <p class="sty-concepts__desc">Вдохновение для тех, кто знает, чего хочет — и для тех, кто пока ищет.</p>
        </div>

        <div class="sty-concepts__grid">
          <div
            v-for="(img, i) in concepts"
            :key="i"
            class="sty-concepts__item"
            @click="openLightbox(i)"
          >
            <img :src="img.src" :alt="`Концепт ${i + 1}`" loading="lazy" />
          </div>
        </div>

        <div class="sty-concepts__cta">
          <p class="sty-concepts__cta-text">Хочешь разместить свой бренд в наших концептах?</p>
          <a href="#for-brands" class="sty-concepts__cta-link">Стать партнёром</a>
        </div>

      </div>
    </section>

    <!-- Приглашение брендов (скрыто) -->
    <section class="sty-invite" v-if="false">
      <div class="container sty-invite__container">

        <div class="sty-invite__text">
          <h2 class="title sty-invite__title">Мы ищем модные бренды</h2>
          <p class="sty-invite__desc">Здесь будут бренды, которые резонируют с людьми, живущими своим. Расскажите о себе — обсудим условия размещения.</p>
          <NuxtLink to="/topartners" class="btn main-btn sty-invite__btn">Партнёрам</NuxtLink>
        </div>

        <div class="sty-invite__image">
          <img
            src="/img/fashion-partners.jpg"
            alt="Мы ищем модные бренды"
            loading="lazy"
          />
        </div>

      </div>
    </section>

    <!-- Философия -->
    <section class="sty-phil">
      <div class="container sty-phil__container">

        <div class="sty-phil__text">
          <div class="sty-phil__label">Философия</div>
          <h2 class="title sty-phil__title">Стиль — это не про одежду</h2>
          <div class="sty-phil__body">
            <p>Одежда — это последнее, что замечают. Сначала замечают, как человек входит в комнату, как он смотрит, как молчит.</p>
            <p>Стиль — это точность. Знание себя настолько хорошее, что выбор становится автоматическим. Не «что надеть» — а «что моё» или «что не моё».</p>
            <p class="sty-phil__conclusion">Мы собираем на платформе бренды и вещи, которые помогают этой точности. Не навязываем образ — предлагаем инструменты для тех, кто уже знает, кто он. Или хочет понять.</p>
          </div>
        </div>

        <div class="sty-phil__image">
          <img
            src="/img/services/style/philosophy.jpg"
            alt="Стиль — это не про одежду"
            loading="lazy"
          />
        </div>

      </div>
    </section>

    <!-- Оффер для брендов -->
    <section class="sty-brands" id="for-brands">
      <div class="sty-brands__bg" aria-hidden="true"></div>
      <div class="container sty-brands__inner">

        <div class="sty-brands__label">Мы ищем модные бренды</div>
        <h2 class="title sty-brands__title">Разместите бренд на платформе,<br>где живёт ваша аудитория</h2>
        <p class="sty-brands__desc">Мы не маркетплейс с тысячами позиций. Мы редакция — отбираем бренды, которые соответствуют образу жизни наших читателей.</p>

        <div class="sty-brands__theses">

          <div class="sty-brands__thesis">
            <div class="sty-brands__thesis-title">Аудитория с характером</div>
            <p class="sty-brands__thesis-text">Люди, которые одеваются для себя, а не для того чтобы вписаться. Они знают, чего хотят — им нужен правильный выбор, а не бесконечная лента.</p>
          </div>

          <div class="sty-brands__thesis">
            <div class="sty-brands__thesis-title">Ваш бренд в контексте жизни</div>
            <p class="sty-brands__thesis-text">Товары появляются в концептах, вайбах и редакционных подборках — не в каталожной сетке среди конкурентов.</p>
          </div>

          <div class="sty-brands__thesis">
            <div class="sty-brands__thesis-title">Вы управляете витриной сами</div>
            <p class="sty-brands__thesis-text">Личный кабинет партнёра — размещаете товары, обновляете коллекции, управляете страницей без нашего участия.</p>
          </div>

        </div>

        <button class="sty-brands__cta" @click="isPartnerModalOpen = true">
          Стать партнёром
        </button>

      </div>
    </section>

    <!-- FAQ -->
    <section class="sty-faq">
      <div class="container sty-faq__container">
        <h2 class="title sty-faq__title">Часто задаваемые вопросы</h2>
        <div class="sty-faq__list">
          <div
            v-for="(item, i) in faq"
            :key="i"
            class="sty-faq__item"
            :class="{ 'sty-faq__item--open': openFaq === i }"
          >
            <button class="sty-faq__question" @click="openFaq = openFaq === i ? null : i">
              <span>{{ item.q }}</span>
              <svg class="sty-faq__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            <div class="sty-faq__answer">
              <div class="sty-faq__answer-inner">{{ item.a }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>

  <ClientOnly>
    <teleport to="body">
      <FormStyle v-if="isModalOpen" @close="isModalOpen = false" />
      <FormStylePartner v-if="isPartnerModalOpen" @close="isPartnerModalOpen = false" />

      <!-- Lightbox -->
      <div v-if="lightboxOpen" class="sty-lightbox" @click.self="closeLightbox">
        <button class="sty-lightbox__close" @click="closeLightbox" aria-label="Закрыть">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <button class="sty-lightbox__nav sty-lightbox__nav--prev" @click="prevConcept" aria-label="Назад">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <div class="sty-lightbox__img">
          <img :src="concepts[lightboxIndex].src" :alt="`Концепт ${lightboxIndex + 1}`" />
        </div>
        <button class="sty-lightbox__nav sty-lightbox__nav--next" @click="nextConcept" aria-label="Вперёд">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button>
        <div class="sty-lightbox__counter">{{ lightboxIndex + 1 }} / {{ concepts.length }}</div>
      </div>

      <Cookie />
    </teleport>
  </ClientOnly>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation as SwiperNavigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import Breadcrumbs from '~/components/Section/Breadcrumbs.vue'
import FormStyle from '~/components/Modals/FormStyle.vue'
import FormStylePartner from '~/components/Modals/FormStylePartner.vue'
import Cookie from '~/components/Section/Cookie.vue'

const isModalOpen        = ref(false)
const isPartnerModalOpen = ref(false)
const activeGender = ref('women')

const womenCats = [
  { name: 'Одежда',           img: '/img/services/style/cat/clothing-w.jpg' },
  { name: 'Обувь',            img: '/img/services/style/cat/shoes-w.jpg' },
  { name: 'Нижнее бельё',    img: '/img/services/style/cat/underwear-w.jpg' },
  { name: 'Аксессуары',      img: '/img/services/style/cat/accessories-w.jpg' },
  { name: 'Сумки',            img: '/img/services/style/cat/bags-w.jpg' },
  { name: 'Парфюм / гигиена', img: '/img/services/style/cat/parfum-w.jpg' },
]

const menCats = [
  { name: 'Одежда',           img: '/img/services/style/cat/clothing-m.jpg' },
  { name: 'Обувь',            img: '/img/services/style/cat/shoes-m.jpg' },
  { name: 'Нижнее бельё',    img: '/img/services/style/cat/underwear-m.jpg' },
  { name: 'Аксессуары',      img: '/img/services/style/cat/accessories-m.jpg' },
  { name: 'Сумки',            img: '/img/services/style/cat/bags-m.jpg' },
  { name: 'Парфюм / гигиена', img: '/img/services/style/cat/parfum-m.jpg' },
]

const activeCats = computed(() => activeGender.value === 'women' ? womenCats : menCats)

const concepts = [
  { src: '/img/services/style/concepts/1.jpg' },
  { src: '/img/services/style/concepts/2.jpg' },
  { src: '/img/services/style/concepts/3.jpg' },
  { src: '/img/services/style/concepts/4.jpg' },
  { src: '/img/services/style/concepts/5.jpg' },
  { src: '/img/services/style/concepts/6.jpg' },
  { src: '/img/services/style/concepts/7.jpg' },
  { src: '/img/services/style/concepts/8.jpg' },
  { src: '/img/services/style/concepts/9.jpg' },
  { src: '/img/services/style/concepts/10.jpg' },
  { src: '/img/services/style/concepts/11.jpg' },
  { src: '/img/services/style/concepts/12.jpg' },
]

const lightboxOpen  = ref(false)
const lightboxIndex = ref(0)

function openLightbox(i) {
  lightboxIndex.value = i
  lightboxOpen.value  = true
}

function closeLightbox() {
  lightboxOpen.value = false
}

function prevConcept() {
  lightboxIndex.value = (lightboxIndex.value - 1 + concepts.length) % concepts.length
}

function nextConcept() {
  lightboxIndex.value = (lightboxIndex.value + 1) % concepts.length
}

function onKeydown(e) {
  if (!lightboxOpen.value) return
  if (e.key === 'ArrowLeft')  prevConcept()
  if (e.key === 'ArrowRight') nextConcept()
  if (e.key === 'Escape')     closeLightbox()
}

onMounted(() => window.addEventListener('keydown', onKeydown))
onUnmounted(() => window.removeEventListener('keydown', onKeydown))

useHead({
  title: 'Стиль — Шарунстор',
  meta: [
    {
      name: 'description',
      content: 'Стиль, чтобы брать от жизни всё. Подбор образа, модные бренды и вдохновение для тех, кто знает, чего хочет.'
    }
  ]
})

const breadcrumbs = [
  { title: 'Главная', url: '/' },
  { title: 'Стиль' }
]

const openFaq = ref(null)
const faq = [
  {
    q: 'Как вы подбираете образ?',
    a: 'Оставьте заявку — стилист свяжется, выяснит задачи, образ жизни и пожелания. Подберём варианты из каталога или предложим концепт под вас.',
  },
  {
    q: 'Это платно?',
    a: 'Есть два формата — бесплатный подбор одежды из каталога по вашему фото и работа со стилистом напрямую по ставке специалиста.',
  },
  {
    q: 'Можно купить конкретную вещь из концепта?',
    a: 'Да — если товар есть в каталоге, его можно добавить в корзину прямо из концепта.',
  },
  {
    q: 'Вы работаете только с российскими брендами?',
    a: 'Нет, происхождение бренда не имеет значения. Но мы работаем или напрямую с брендами, или с официальными дистрибьюторами и дилерами иностранных торговых марок.',
  },
  {
    q: 'Как бренду попасть на платформу?',
    a: 'Оставьте заявку в блоке для брендов — менеджер свяжется и расскажет об условиях. Мы работаем с прямыми производителями и официальными дилерами.',
  },
  {
    q: 'Бренд сам управляет своими товарами?',
    a: 'Да — через личный кабинет партнёра. Размещаете товары, обновляете коллекции, управляете страницей без нашего участия.',
  },
  {
    q: 'Какие требования к контенту?',
    a: 'Качественные фото с естественной цветокоррекцией. AI-контент для демонстрации самого товара не допустим — кроме концептов и кампейнов. AI-обработка реальных фото допустима. Если контента нет — поможем создать.',
  },
]
</script>

<style scoped lang="scss">
$dark: #1B1918;
$grey: #666;
$mobile: 48em;
$tablet: 75em;

// ─── Hero ─────────────────────────────────────────────────────────────────────
.sty-hero {
  padding: 6rem 0 8rem;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6rem;
    align-items: center;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4rem;
    }
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(27, 25, 24, 0.4);
    margin-bottom: 2.4rem;
  }

  &__title {
    font-size: 5.6rem;
    line-height: 1.08;
    margin-bottom: 2rem;
    color: $dark;

    @media (max-width: $tablet) { font-size: 4.2rem; }
    @media (max-width: $mobile) {
      font-size: 3.4rem;
      br { display: none; }
    }
  }

  &__desc {
    font-size: 1.8rem;
    line-height: 1.5;
    color: $grey;
    margin-bottom: 3.2rem;
  }

  &__lead {
    font-size: 1.6rem;
    line-height: 1.5;
    color: $dark;
    font-style: italic;
    margin-bottom: 2.4rem;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 3.2rem;
    flex-wrap: wrap;
  }

  &__link {
    font-size: 1.4rem;
    color: $grey;
    text-decoration: none;
    border-bottom: 1px solid rgba(102, 102, 102, 0.3);
    padding-bottom: 0.2rem;
    transition: color 0.2s, border-color 0.2s;

    &:hover {
      color: $dark;
      border-color: $dark;
    }
  }

  &__image {
    @media (max-width: $tablet) { order: -1; }

    img {
      width: 100%;
      height: 72rem;
      object-fit: cover;
      object-position: center top;
      border-radius: 0.4rem;
      display: block;

      @media (max-width: $tablet) { height: 52rem; }
      @media (max-width: $mobile) { height: 36rem; }
    }
  }
}

// ─── Каталог ──────────────────────────────────────────────────────────────────
.sty-catalog {
  padding: 10rem 0 12rem;
  background: #f7f7f7;

  &__head {
    text-align: center;
    max-width: 64rem;
    margin: 0 auto 4rem;
  }

  &__title { margin-bottom: 1.6rem; }

  &__desc {
    font-size: 1.6rem;
    color: $grey;
    line-height: 1.65;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    gap: 0.4rem;
    margin-bottom: 4.8rem;
  }

  &__tab {
    padding: 1rem 3.2rem;
    font-size: 1.2rem;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    font-weight: 600;
    font-family: inherit;
    border: 1px solid rgba(27, 25, 24, 0.18);
    background: transparent;
    color: $grey;
    cursor: pointer;
    border-radius: 2px;
    transition: background 0.2s, color 0.2s, border-color 0.2s;

    &--active {
      background: $dark;
      border-color: $dark;
      color: #fff;
    }

    &:not(&--active):hover {
      border-color: $dark;
      color: $dark;
    }
  }

  &__swiper { overflow: visible; }

  :deep(.sty-catalog__swiper .swiper-button-prev),
  :deep(.sty-catalog__swiper .swiper-button-next) {
    top: 40%;
    color: $dark;
  }

  :deep(.sty-catalog__swiper .swiper-button-prev::after),
  :deep(.sty-catalog__swiper .swiper-button-next::after) {
    font-size: 1.6rem;
  }

  &__card {
    display: block;
    position: relative;
    overflow: hidden;
    border-radius: 0.4rem;
    aspect-ratio: 3 / 4;
    text-decoration: none;

    &:hover &-img img { transform: scale(1.05); }
  }

  &__card-img {
    position: absolute;
    inset: 0;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      filter: grayscale(100%);
      transition: transform 0.55s ease;
    }
  }

  &__card-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.18) 40%, rgba(0,0,0,0) 65%);
    z-index: 1;
  }

  &__card-body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 2.4rem 2.4rem 2.8rem;
    z-index: 2;
  }

  &__card-name {
    font-size: 1.8rem;
    font-weight: 600;
    color: #fff;
    line-height: 1.25;
    letter-spacing: 0.02em;
  }
}

// ─── Витрина концептов ────────────────────────────────────────────────────────
.sty-concepts {
  padding: 10rem 0 12rem;

  &__head {
    text-align: center;
    max-width: 60rem;
    margin: 0 auto 5.6rem;
  }

  &__title { margin-bottom: 1.6rem; }

  &__desc {
    font-size: 1.6rem;
    color: $grey;
    line-height: 1.65;
  }

  &__grid {
    columns: 3;
    column-gap: 1.6rem;

    @media (max-width: $tablet) { columns: 2; }
    @media (max-width: $mobile) { columns: 1; }
  }

  &__item {
    break-inside: avoid;
    margin-bottom: 1.6rem;
    cursor: pointer;
    overflow: hidden;
    border-radius: 0.4rem;
    display: block;

    img {
      width: 100%;
      display: block;
      transition: transform 0.45s ease;
    }

    &:hover img { transform: scale(1.03); }
  }

  &__cta {
    display: flex;
    align-items: center;
    gap: 2.4rem;
    margin-top: 6.4rem;
    padding-top: 4rem;
    border-top: 1px solid rgba(27, 25, 24, 0.08);
    flex-wrap: wrap;

    @media (max-width: $mobile) {
      flex-direction: column;
      align-items: flex-start;
      gap: 1.6rem;
    }
  }

  &__cta-text {
    font-size: 1.7rem;
    color: $dark;
    line-height: 1.5;
    flex: 1;
  }

  &__cta-link {
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: $dark;
    text-decoration: none;
    border-bottom: 1px solid $dark;
    padding-bottom: 0.2rem;
    white-space: nowrap;
    transition: opacity 0.2s;

    &:hover { opacity: 0.6; }
  }
}

// ─── Философия ────────────────────────────────────────────────────────────────
.sty-phil {
  padding: 10rem 0;
  background: #f7f7f7;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8rem;
    align-items: center;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4.8rem;
    }
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(27, 25, 24, 0.35);
    margin-bottom: 2.4rem;
  }

  &__title { margin-bottom: 3.2rem; }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 1.8rem;

    p {
      font-size: 1.7rem;
      line-height: 1.7;
      color: $grey;
    }
  }

  &__conclusion {
    font-size: 1.7rem !important;
    line-height: 1.6 !important;
    color: $dark !important;
    font-style: italic;
    padding-top: 0.8rem;
    border-top: 1px solid rgba(27, 25, 24, 0.1);
    margin-top: 0.4rem;
  }

  &__image {
    @media (max-width: $tablet) { order: -1; }

    img {
      width: 100%;
      height: 56rem;
      object-fit: cover;
      border-radius: 0.4rem;
      display: block;

      @media (max-width: $tablet) { height: 42rem; }
      @media (max-width: $mobile) { height: 30rem; }
    }
  }
}

// ─── Оффер для брендов ───────────────────────────────────────────────────────
.sty-brands {
  position: relative;
  padding: 12rem 0;
  overflow: hidden;

  &__bg {
    position: absolute;
    inset: 0;
    background: url('/img/services/style/for-brands.jpg') center / cover no-repeat;
    z-index: 0;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(10, 9, 9, 0.82);
    }
  }

  &__inner {
    position: relative;
    z-index: 1;
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.32);
    margin-bottom: 2.4rem;
  }

  &__title {
    color: #fff;
    font-size: 4.8rem;
    max-width: 80rem;
    margin-bottom: 2.4rem;
    line-height: 1.08;

    @media (max-width: $tablet) {
      font-size: 3.8rem;
      br { display: none; }
    }
    @media (max-width: $mobile) { font-size: 3rem; }
  }

  &__desc {
    font-size: 1.8rem;
    color: rgba(255, 255, 255, 0.55);
    line-height: 1.65;
    max-width: 58rem;
    margin-bottom: 6.4rem;
  }

  &__theses {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4rem;
    margin-bottom: 6.4rem;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 3.2rem;
    }
  }

  &__thesis {
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    padding-top: 2.4rem;
  }

  &__thesis-title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1.2rem;
  }

  &__thesis-text {
    font-size: 1.5rem;
    color: rgba(255, 255, 255, 0.5);
    line-height: 1.7;
  }

  &__cta {
    display: inline-block;
    padding: 1.6rem 4rem;
    background: #fff;
    color: $dark;
    border: none;
    border-radius: 2px;
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover { opacity: 0.88; }
  }
}

// ─── Lightbox ─────────────────────────────────────────────────────────────────
.sty-lightbox {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(10, 9, 9, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;

  &__img {
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      max-height: 90vh;
      object-fit: contain;
      display: block;
      border-radius: 0.4rem;
    }
  }

  &__close {
    position: absolute;
    top: 2.4rem;
    right: 2.4rem;
    width: 4.8rem;
    height: 4.8rem;
    background: rgba(255, 255, 255, 0.08);
    border: none;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover { background: rgba(255, 255, 255, 0.16); }
  }

  &__nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 5.6rem;
    height: 5.6rem;
    background: rgba(255, 255, 255, 0.08);
    border: none;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover { background: rgba(255, 255, 255, 0.18); }

    &--prev { left: 2.4rem; }
    &--next { right: 2.4rem; }

    @media (max-width: $mobile) {
      width: 4rem;
      height: 4rem;
      &--prev { left: 1.2rem; }
      &--next { right: 1.2rem; }
    }
  }

  &__counter {
    position: absolute;
    bottom: 2.4rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 1.3rem;
    color: rgba(255, 255, 255, 0.45);
    letter-spacing: 0.08em;
  }
}

// ─── FAQ ──────────────────────────────────────────────────────────────────────
.sty-faq {
  padding: 10rem 0;
  background: #f7f7f5;

  &__container { max-width: 80rem; }

  &__title { margin-bottom: 5rem; }

  &__list { display: flex; flex-direction: column; }

  &__item {
    border-bottom: 1px solid rgba(27, 25, 24, 0.1);

    &:first-child { border-top: 1px solid rgba(27, 25, 24, 0.1); }

    &--open &-icon { transform: rotate(180deg); }
    &--open .sty-faq__answer { max-height: 40rem; }
  }

  &__question {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    padding: 2.4rem 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    font-size: 1.6rem;
    font-weight: 500;
    color: $dark;
    font-family: inherit;
    line-height: 1.4;
  }

  &__icon {
    flex-shrink: 0;
    color: $dark;
    transition: transform 0.3s ease;
  }

  &__answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.35s ease;
  }

  &__answer-inner {
    padding-bottom: 2.4rem;
    font-size: 1.5rem;
    line-height: 1.7;
    color: $grey;
  }

  @media (max-width: $mobile) {
    padding: 6rem 0;
    &__title { margin-bottom: 3.2rem; }
    &__question { font-size: 1.5rem; }
  }
}

// ─── Приглашение брендов ──────────────────────────────────────────────────────
.sty-invite {
  padding: 10rem 0;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8rem;
    align-items: stretch;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4rem;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__title { margin-bottom: 2rem; }

  &__desc {
    font-size: 1.7rem;
    line-height: 1.6;
    color: $grey;
    margin-bottom: 3.2rem;
    max-width: 46rem;
  }

  &__btn {
    align-self: flex-start;
  }

  &__image {
    border-radius: 0.4rem;
    overflow: hidden;

    @media (max-width: $tablet) { order: -1; }

    img {
      width: 100%;
      height: 100%;
      min-height: 32rem;
      object-fit: cover;
      display: block;

      @media (max-width: $mobile) { min-height: 30rem; }
    }
  }

  @media (max-width: $mobile) {
    padding: 6rem 0;
  }
}
</style>
